export default "__VITE_ASSET__ed1cb714__"